import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-wait-modal',
  templateUrl: './wait-modal.component.html',
  styleUrls: ['./wait-modal.component.css']
})
export class WaitModalComponent implements OnInit {

  @ViewChild('waitModal', { static: false }) waitModal: ModalDirective;

  readonly SCREEN_ID = 'O83';

  config: ModalOptions = {
    animated: false
  };

  constructor() { }

  ngOnInit() {
  }

  showModal(): void {
    this.waitModal.config = this.config;
    this.waitModal.show();
  }

  hideModal(): void {
    this.waitModal.hide();
  }

}
